import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/ContractorCostQuotes"
    : "SLN/SolarentOperator/ContractorCostQuotes";

const ContractorCostQuotesReviewApi = {
  getCostQuotesByRequest: async (source, requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `${baseBySource(source)}/GetCostQuotesByRequest?requestId=${requestId}`
      );
      if (!res) {
        return { ok: false, message: "پاسخ خالی از سرور", data: [] };
      }
      return {
        ok: res?.isSuccess !== false,
        message: res?.message || "",
        data: res?.data ?? res ?? [],
      };
    } catch (e) {
      return {
        ok: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "خطا در دریافت پیشنهادهای هزینه",
        data: [],
      };
    }
  },

  getCostQuoteDetails: async (source, costQuoteId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetCostQuoteDetails?costQuoteId=${costQuoteId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  acceptContractorCostQuote: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/AcceptContractorCostQuote`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  rejectContractorCostQuote: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RejectContractorCostQuote`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  getEquipmentSnapshot: async (source, snapshotId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetEquipmentSnapshot?snapshotId=${snapshotId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },
};

export default ContractorCostQuotesReviewApi;
